import { PageLayout } from '../components/PageLayout';
import { ArchitectureSection } from '../components/sections/ArchitectureSection';

export const Architecture = () => (
    <PageLayout>
        <ArchitectureSection />
    </PageLayout>
);
